import React from "react";
import _, { isEmpty } from "underscore";
import { isNotEmpty } from "../../../framework/utils";
import { optional, parseBoolean } from "../../../utils/lang";
import Actions from "./actions";

export default class MobileLayout extends React.Component {
    getHeaderProps() {
        return _.pick(
                this.props,
                [
                    "leftActions",
                    "rightActions",
                    "title",
                    "showLogo",
                ]
            )
    }

    render() {
        const showHeader = !optional(this.props.hideHeader, false),
            fullscreen = parseBoolean(optional(this.props.fullscreen, true)),
            transition = "animated animated-fast " + (this.props.transition || "fadeIn");
            //transition = "animated animated-fast " + (this.props.transition || "slideInRight");
        let className="mobile-screen " + transition;

        if (fullscreen) {
            className += " fullheight";
        }

        if (!showHeader) {
            className += " mobile-screen--no-header";
        }

        return(
            <div
                className={className}
            >
                {showHeader && <MobileHeader
                    {...this.getHeaderProps()}
                />}
                <MobileBody>
                    {this.props.children}
                </MobileBody>
            </div>
        )
    }
}

export class MobileHeader extends React.Component {
    render() {
        const leftActions = optional(this.props.leftActions, []),
            rightActions = optional(this.props.rightActions, []),
            title = this.props.title,
            showLogo = parseBoolean(optional(this.props.showLogo, false)) && isEmpty(title);

        return(
            <div
                className={"mobile-header" + (isNotEmpty(this.props.className) ? " " + this.props.className : "")}
            >
                {isNotEmpty(leftActions) && <div
                    className="mobile-header__actions"
                >
                    <Actions
                        actions={leftActions}
                    />
                </div>}
                {showLogo && <div
                    className="mobile-header__logo"
                >
                    <img
                        src="/resources/images/logo.svg"
                    />
                </div>}
                <div
                    className="mobile-header__spacer"
                />
                {isNotEmpty(title) && <div
                    className="mobile-header__title"
                >
                    {title}
                </div>}
                <div
                    className="mobile-header__spacer"
                />
                {isNotEmpty(rightActions) && <div
                    className="mobile-header__actions"
                >
                    <Actions
                        actions={rightActions}
                    />
                </div>}
            </div>
        )
    }
}

class MobileBody extends React.Component {
    render() {
        return(
            <div
                className="mobile-content"
            >
                {this.props.children}
            </div>
        )
    }
}